import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <div className='navbar-logo'>
          <img src="images/log.png" alt='' width="120px" height="90px"/>
          </div>
          <div className='menu-icon' >
          </div>
            <div className='nav-item'>
              <Link to='/' className='nav-links'>
                Home
              </Link>
            </div>
            <div className='nav-item'>
              <Link
                to='/services'
                className='nav-links'
              >
                História
              </Link>
            </div>
            <div className='nav-item'>
              <Link
                to='/products'
                className='nav-links'
              >
                Produtos
              </Link>
            </div>

            <div>
              <Link
                to='/sign-up'
                className='nav-links'
              >
                Contato
              </Link>
            </div>
            <div>
              <Link
                to='/carrinho'
                className='nav-links'
              ><a href="carrinho" class="fas fa-shopping-cart"><span></span></a>

                <div class="icons">
            
        </div>
              </Link>
            </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
